<template lang="pug">
  .b-tariff-tile(:class="{ selected, checked }")
    ._discount(v-if="showBonus && tariff.pricePerDay > 0") -20%
    ._name {{ tariff.name }}
    ._price-before-discount(v-if="showBonus && tariff.pricePerDay > 0") {{ tariff.pricePerDay * 30 }} ₽/месяц
    ._price-before-discount(v-else)
    ._price-actual {{ tariff.pricePerDay * 30 * ( showBonus ? 0.8 : 1 ) }} ₽
    ._desc(v-if="tariff.pricePerDay > 0") Месяц
    ._desc(v-else) Бессрочно
    //._bonus(v-if="showBonus") +{{ tariff.bonus / 100 }} бонусов
    ._options
      ._option(v-if="tariff.maxProjects > 999999")
        Icon(name="infinity")
      ._option(v-else) {{ tariff.maxProjects }}
      ._option(v-if="tariff.maxStorage > 999999")
        Icon(name="infinity")
      ._option(v-else) {{ tariff.maxStorage }}
      ._option(v-for="option in tariff.options")
        Icon(:name="option ? 'checked-true-sm' : 'checked-cross'")
    Btn(lg :disabled="checked" @click="$emit('check', tariff)") Выбрать
    ._selected-wrap
      ._selected-label(v-if="selected") Ваш тариф
</template>

<script>
export default {
  name: 'TariffTile',
  props: {
    tariff: Object,
    checked: Boolean,
    selected: Boolean,
    showBonus: Boolean,
  },
};
</script>

<style scoped lang="scss">

.tariff-tile {
  background: #fff;
  border-radius: 24px;
  padding: 30px 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  //gap: 15px;
  position: relative;

  box-sizing: border-box;
  border: 2px solid #33A1FB;
  transition: ease .3s;

  &__discount {
    position: absolute;
    top: -11px;
    background: #33A1FB;
    border-radius: 34px;
    width: 58px;
    height: 22px;
    transition: ease .3s;

    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.01em;

    color: #FFFFFF;
  }

  &__name {
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.01em;
    color: #1E3147;
    margin-bottom: 15px;
    text-align: center;
    height: 35px;
  }

  &__price-before-discount {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.01em;
    color: #788CA1;
    text-decoration: line-through;
  }

  &__price-actual {
    font-weight: 700;
    font-size: 30px;
    line-height: 38px;
    letter-spacing: 0.01em;
    color: #33A1FB;
  }

  &__desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #788CA1;
    margin-bottom: 10px;
  }

  &__bonus {
    width: 118px;
    height: 24px;

    background: #33A1FB;
    border-radius: 14px;

    font-weight: 500;
    font-size: 13px;
    line-height: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #FFFFFF;
  }

  &__option {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 39px;
    border-bottom: 1px solid #EBEFF2;

    &:last-child {
      border-bottom: none;
      margin-bottom: 25px;
    }
  }

  &.selected &__option {
    border-bottom-color: #324458;
  }

  &.selected &__price,
  &.selected &__name {
    color: #FFFFFF;
  }

  &.selected {
    background: #1E3147;
    //overflow: hidden;
    color: #FFFFFF;
    border-color: #F8F9FC;
  }

  &:hover, &.checked {
    border: 2px solid #FED56D;
  }

  &:hover &__discount, &.checked &__discount {
    background: #FED56D;
  }

  &__selected-wrap {
    border-radius: 0 0 24px 24px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  &__selected-label {
    background: #33A1FB;
    border-radius: 16px 16px 0 0;
    color: #fff;
    font-family: 'Geometria', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.01em;
    width: 125px;
    height: 38px;
    position: relative;
    margin: 0 auto;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      width: 0;
      height: 0;
      border: 7px solid #33A1FB;
      border-top-color: transparent;
      border-top-width: 14px;
      border-bottom-width: 14px;
    }

    &:before {
      left: -13px;
      border-left-color: transparent;
    }

    &:after {
      right: -13px;
      border-right-color: transparent;
    }
  }
}

</style>
